import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix, SearchType } from '@/types'

export interface ReserveGroupReserve {
  id: number
  reserveStatus: SystemCode
  reserveGroupId: number
  bibliographyRealId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SearchType
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  displayPublished: string
  displaySize: string
  collectionFlag: CollectionFlag
  revision: number
}

export function ReserveGroupReserveFromJSON(json: any): ReserveGroupReserve {
  return {
    id: exists(json, 'id') ? json.id : 0,
    reserveStatus: exists(json, 'reserve_status')
      ? SystemCodeFromJSON(json.reserve_status)
      : defaultSystemCode(),
    reserveGroupId: exists(json, 'reserve_group_id')
      ? json.reserve_group_id
      : 0,
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : '',
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    searchType: exists(json, 'search_type')
      ? json.search_type
      : SearchType.Book,
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    displaySize: exists(json, 'display_size') ? json.display_size : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
